import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {APP_CONFIG, ConfigService} from './configService';

export class Param {
  trackers?: { cookiePurposes: string; state: boolean; }[];
  expiration?: number;
}

@Injectable({ providedIn: 'root' })
export class CookieService {

  constructor(private http: HttpClient, private configService: ConfigService) {
  }

  getCookiePageDetails(apiKey: string, version: string, market: string, lang: string): Observable<any> {
    const base = APP_CONFIG.commonApi + 'v3/legalPage';
    const query = `?apiKey=${apiKey}&version=${version}&market=${market}&lang=${lang}&format=mobile`;
    return this.http.get(base + query,
      { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) });
  }

  getClient(apiKey: string, lang: string, country: string, clientVersion?: string): Observable<any> {
    const base = APP_CONFIG.commonApi + 'v3/configurations/' + apiKey;
    const versionPart = clientVersion !== undefined ? `&version=${clientVersion}` : '';
    const url = `${base}?lang=${lang}&country=${country}${versionPart}`;
    return this.http.get(url, this.configService.getHeader(apiKey));
  }
}
